// Using an `any` type here because of how low-level this function is &
// its varied use across product apps
export const isRenderable = children => children != null && children !== false;